import { ISelectInputOptionsProvider } from '../../components/singleInputComponents/select/selectInput.component';
import * as Model from '../../../models/models';
import { ErrorInformation } from '../../../core/services/errorRedirectService/errorInformation.model';
import { IErrorRedirectService } from '../../../core/services/errorRedirectService/errorRedirect.service';
import { QuoteWizardViewModel } from '../../quoteWizard.viewmodel';
import { IBrand } from '../../../models/models';
import { BrandRepository } from '../../../repositories/brand.repository';
  
export class BrandGateway {
    private optionsBinding: string;

    public static $inject = ['brandRepository', 'errorRedirectService', 'orderByFilter'];

    public constructor(private brandRepository: BrandRepository,
        private errorRedirectService: IErrorRedirectService,
        private orderBy: ng.IFilterOrderBy) {
        this.optionsBinding = 'item.id as item.description for item in $ctrl.options';
    }

    public loadBrands(verticalId: string): ng.IPromise<any> {
        return this.brandRepository.getBrands(verticalId)
            .then((result: Model.IBrand[]) => {
                return result;
            })
            .catch((reason: string) => {
                const error = new ErrorInformation();
                error.errorMessage = reason;
                error.errorDetails = reason;
                this.errorRedirectService.redirectToErrorState(error);
                return error;
            });
    }

    public getSelectInputOptionsProvider(brands: IBrand[], viewModel: QuoteWizardViewModel): ISelectInputOptionsProvider {
        let otherBrand: IBrand;
        const selectInputBrands: IBrand[] = [];
        for (const brand of this.orderBy(brands, 'description')) {
            // alphabetical, but put other at the end
            if (brand.description === 'Other') {
                otherBrand = brand;
                continue;
            }
            // exclude isActive=0, UNLESS the current value is one of those, then include that one
            if (brand.isActive === false) {
                if (viewModel.clientStateContext.submissionRequest.brandId !== brand.id) {
                    continue;
                }
            }
            selectInputBrands.push(brand);
        }
        // add other to the end of the list, if it's found
        if (angular.isDefined(otherBrand)) {
            selectInputBrands.push(otherBrand);
        }
        return {
            getOptionsBinding: () => this.optionsBinding,
            getOptionsList: () => selectInputBrands
        };
    }
}